import {
    api_setInvoicePreview,
    api_postAppointmentRequest,
    api_getAppointmentUploadURL
} from "./scheduling.api";
import {
    setServiceType,
    setPaymentMethod,
    setIsImmediate,
    setSelectedState,
    setVetProfileId,
    setRequestReason,
    setVetProfile,
    setPickedDate,
    setSelectedPetID,
    setAdditionalInfo,
    setVetId,
    setIsGiftReceived,
    setPromotionCode,
    setPrice,
    setPickedTimeSlot,
    setPhotos,
    setVideo,
    clearAppointmentInfo,
    setPDF,
    deletePhotos,
    deletePhoto,
    deleteVideo
} from "./scheduling.reducers";

export const updateServiceType = params => dispatch => {
    dispatch(setServiceType(params));
};

export const updatePaymentMethod = params => dispatch => (
    dispatch(setPaymentMethod(params))
);

export const updateIsImmediate = params => dispatch => (
    dispatch(setIsImmediate(params))
);

export const updateSelectedState = params => dispatch => (
    dispatch(setSelectedState(params))
);

export const updateVetProfileId = params => dispatch => (
    dispatch(setVetProfileId(params))
);

export const updateRequestReason = params => dispatch => (
    dispatch(setRequestReason(params))
);

export const updateVetProfile = params => dispatch => (
    dispatch(setVetProfile(params))
);

export const updatePickedDate = params => dispatch => (
    dispatch(setPickedDate(params))
);

export const updateSelectedPetID = params => dispatch => (
    dispatch(setSelectedPetID(params))
);

export const updateAdditionalInfo = params => dispatch => (
    dispatch(setAdditionalInfo(params))
);

export const updateVetId = params => dispatch => (
    dispatch(setVetId(params))
);

export const updatePromotionCode = params => dispatch => (
    dispatch(setPromotionCode(params))
);

export const updatePickedTimeSlot = params => dispatch => (
    dispatch(setPickedTimeSlot(params))
);

export const uploadPhotos = (photo, idx) => dispatch => (
    dispatch(setPhotos({photo, idx}))
);

export const cleanUpPhotos = () => dispatch => (
    dispatch(deletePhotos())
);
export const cleanUpPhoto = (idx) => dispatch => (
    dispatch(deletePhoto(idx))
);
export const uploadVideo = (photo) => dispatch => (
    dispatch(setVideo(photo))
);
export const cleanUpVideo = () => dispatch => (
    dispatch(deleteVideo())
);
export const setInvoicePreview = params => dispatch => (
    api_setInvoicePreview(params).then(res => {
        return res;
    })
);

export const updateIsGiftReceived = params => dispatch => (
    dispatch(setIsGiftReceived(params))
);
export const postAppointmentRequest = params => dispatch => (
    api_postAppointmentRequest(params).then(res => {
        return res;
    })
);

export const getAppointmentUploadURL = (id, isVideoUpload=false) => dispatch => (
    api_getAppointmentUploadURL(id, isVideoUpload).then(res => {
        return res;
    })
);

export const savePDF = pdf => dispatch => (
    dispatch(setPDF(pdf))
);

export const clearInfo = () => dispatch => (
    dispatch(clearAppointmentInfo())
);
